import { render } from "./SidebarNav.vue?vue&type=template&id=1564226e"
import script from "./SidebarNav.vue?vue&type=script&lang=js"
export * from "./SidebarNav.vue?vue&type=script&lang=js"
script.render = render

export default script